var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.user)?_c('div',[_c('v-row',[_c('v-col',{attrs:{"cols":"24","sm":"12","md":"6"}},[_c('ChangeMail')],1),_c('v-col',{attrs:{"cols":"24","sm":"12","md":"6"}},[_c('DeleteAccount')],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }